import { InputLabel, styled } from '@mui/material';

export const Label = styled(InputLabel)({
    fontSize: '18px',
    fontWeight: 400,
    color: '#131313',
});
